import styled, { css, ThemeContext } from 'styled-components';
import { lighten, darken, desaturate } from 'polished';
import Select from 'react-select/creatable';

import { fadeIn } from 'styles/animation';

export const Container = styled.div`
  margin: 0 0 10px 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
  color: ${props => props.theme.fontColor};
  ${props =>
    props.error &&
    css`
      height: 59px;
      max-height: 59px;
    `}
  &:last-of-type {
    margin: 0px;
  }

  /* ICON ERROR */
  i {
    text-decoration: none;
    font-style: normal;

    position: absolute;
    align-self: flex-end;
    padding: 0.4rem 0.6rem 0rem 0.6rem;

    svg {
      font-size: 0.875rem;
      stroke-width: 3px;
      /* opacity: 0.9; */
      /* color: ${props => props.theme.fontColor}; */

      -webkit-transition: all 0.15s ease 0s;
      transition: all 0.15s ease 0s;

      &:hover {
        opacity: 1;
      }
    }
  }
`;

export const SelectComponent = styled(Select)`
  min-width: 200px;
  width: 100%;
  min-height: 38px;
  /* margin-bottom: 20px; */
  /* div {
    color:${props =>
      props.isMulti ? props.theme.lightFontColor : props.theme.fontColor};
  } */

  > div {
    ${props =>
      props.fill
        ? css`
            background: transparent;
          `
        : css`
            background: ${props =>
              props.theme.name === 'dark'
                ? lighten(0.05, props.theme.cardBackgroud)
                : darken(0.01, props.theme.cardBackgroud)};
          `}

    border-color: ${({ theme }) =>
      theme.name === 'dark'
        ? lighten(0.1, theme.cardBackgroud)
        : darken(0.15, theme.cardBackgroud)};
    ${({ error }) =>
      error === 'true' &&
      css`
        border-color: ${props => props.theme.error};
      `}



    &:focus,&:hover {
      border: 1px solid
        ${props => desaturate(0.5, props.theme.button.primary.in)};
    }

    ${({ error }) =>
      error &&
      css`
        border-color: ${props => props.theme.error};

        &:focus,
        &:hover {
          border-color: ${props => props.theme.error};
        }
      `}

    &:nth-child(1) {
      div {
        /* opacity: 0.9; */
        color: ${props => props.theme.fontColor};
      }

      &:focus-within {
        color: red;
      }
    }

    /* MENEU OPENED*/
    &:nth-child(3) {
      background-color: #fff;
      color: #1d253b;
      background-color: #fff;
      border-radius: 4px;

      background-clip: padding-box;
      border-width: 0 solid rgba(34, 42, 66, 0.15);
      box-shadow: 0 50px 100px rgba(50, 50, 93, 0.1),
        0 15px 35px rgba(50, 50, 93, 0.15), 0 5px 15px rgba(0, 0, 0, 0.1);

      animation: ${fadeIn} 0.1s ease-in;
      display: block;

      &:hover {
        border: 0;
      }

      &::before {
        display: inline-block;
        position: absolute;
        width: 0;
        height: 0;
        vertical-align: middle;
        content: '';
        color: #fff;

        ${props =>
          props.menuPlacement === 'top'
            ? css`
                top: 100%;
                left: auto;
                bottom: -5px;
                right: 10px;
                border-top: 0.4em solid;
                border-right: 0.4em solid transparent;
                border-left: 0.4em solid transparent;
              `
            : css`
                top: -5px;
                left: auto;
                right: 10px;

                border-bottom: 0.4em solid;
                border-right: 0.4em solid transparent;
                border-left: 0.4em solid transparent;
              `}
      }

      > div {
        > div {
          -webkit-transition: all 0.15s linear;
          transition: all 0.15s linear;
          &:hover {
            /* background-color: hsla(0, 0%, 87.1%, 0.3); */
          }
        }
      }
    }
  }

  svg {
    /* opacity: 0.8; */
    /* color: ${props => props.theme.fontColor}; */
  }


`;

export const customStyles = {
  placeholder: (provided, state) => ({
    ...provided,
    fontSize: '0.8rem',
    opacity: 0.6,
    color: ThemeContext.fontColor,
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isDisabled
      ? null
      : state.isSelected
      ? null
      : state.isFocused
      ? 'hsla(0, 0%, 87.1%, 0.3)'
      : null,
    color: state.isDisabled
      ? 'hsla(0, 0%, 0%, 0.3)'
      : state.isSelected
      ? '#3358f4'
      : '#1d253b',
    fontWeight: state.isSelected ? '600' : '400',
    cursor: state.isDisabled ? 'not-allowed' : 'pointer',
  }),
  singleValue: base => ({
    ...base,
    padding: '0 8px',
    borderRadius: 5,
    background: '#3358f4',
    color: 'white',
    display: 'flex',
  }),
  multiValueLabel: base => {
    return {
      ...base,
      color: ThemeContext.lightFontColor,
      // color: 'green',
    };
  },
  multiValueRemove: (base, state) => {
    return {
      ...base,
      display: state.isDisabled ? 'none' : 'block',
      // color: ThemeContext.lightFontColor,
      ':hover': {
        backgroundColor: '#fff',
        color: '#3358f4',
      },
    };
  },
  valueContainer: (base, state) => {
    return {
      ...base,
      maxHeight: '100px',
      transition: 'all .2s ease',
      '&:hover': {
        transition: 'all .2s ease',
        overflowY: 'auto',
      },
      '&:focus': {
        transition: 'all .2s ease',
        overflowY: 'auto',
      },

      '::-webkit-scrollbar': {
        padding: '10px 0',
        transition: 'all .2s ease',
        width: '6px',
      },

      '::-webkit-scrollbar:hover': {
        transition: 'all .2s ease',
        width: '15px !important',
      },

      /* Track */
      '::-webkit-scrollbar-track': {
        display: 'none',
        opacity: 0,
        transition: 'all .2s ease',
        width: '15px',
        padding: '10px 0',

        right: 0,
        position: 'absolute',
        backgroundColor: '#aaa',
      },

      '::-webkit-scrollbar-track:hover': {
        display: 'block',
        opacity: 1,
        width: '15px',
        backgroundColor: '#f1f1f1',
      },

      '::-webkit-scrollbar-track:active': {
        display: 'block',
        opacity: 1,
        width: '15px',
        backgroundColor: '#f1f1f1',
      },

      /* Handle */
      '::-webkit-scrollbar-thumb': {
        borderRadius: '6px',
        transition: 'all .2s ease',
        width: '6px',
        right: '2px',
        position: 'absolute',
        backgroundColor: '#a1a1a1',
      },
      '::-webkit-scrollbar-thumb:hover': {
        width: '12px',
      },
      '::-webkit-scrollbar-thumb:active': {
        width: '12px',
      },
    };
  },
  multiValue: (base, state) => {
    return {
      ...base,
      padding: '0 8px',
      borderRadius: 5,
      background: state.data.__isNew__ ? '#4E516C' : '#3358f4',
      alignItems: 'center',
      display: 'flex',
      opacity: state.isDisabled ? '0.7' : '1',
    };
  },
  control: base => ({
    ...base,
    cursor: 'default',
  }),
  input: base => ({
    ...base,
    color: ThemeContext.fontColor,
  }),
  indicatorSeparator: base => ({
    backgroundColor: 'transparent',
  }),
  loadingIndicator: base => ({
    display: 'flex',
    padding: 4,
    span: {
      height: '0.5em',
      width: '0.5em',
      marginRight: -5,
    },
  }),
};

export const menuHeaderStyle = {
  padding: '8px 12px',
  background: '#fff',
  color: 'hsla(0, 0%, 0%, 0.3)',
};

export const ErrorMessage = styled.span`
  margin-top: 1.5px;
  align-self: flex-start;
  display: flex;
  flex: 1 1;
  flex-wrap: wrap;
  font-size: 0.75rem;
  color: ${props => props.theme.error};
`;

export const OptionContent = styled.div`
  display: flex;
  padding: 2px 8px 2px 8px;
`;

export const OptionComercial = styled.div`
  display: flex;
  align-items: center;
  span {
    color: grey;
    margin-left: 5px;
    font-style: oblique;
  }
`;
